import {
	pushEventToDataLayer,
	EnhancedEcommerceProductDetailImpressionEvent,
	EnhancedEcommerceProductFieldObject,
	GA4ViewItemEvent,
	GA4Item,
} from "@secureo/common/components/GoogleTagManager"

export const trackProductDetailImpression = (
	name: string,
	masterVariantSku: string,
	singleGrossPriceCents: number,
	brand: string,
	category: string,
	list: string,
) => {
	const singleGrossPriceEuros = singleGrossPriceCents / 100

	const productFieldObject: Omit<EnhancedEcommerceProductFieldObject, "position"> = {
		id: masterVariantSku,
		name,
		price: singleGrossPriceEuros,
		brand,
		category,
	}

	const event: EnhancedEcommerceProductDetailImpressionEvent = {
		event: "productDetail",
		ecommerce: {
			detail: {
				actionField: {
					list,
				},
				products: [productFieldObject],
			},
		},
	}

	pushEventToDataLayer(event)
}

export const trackGA4ViewItem = (
	name: string,
	masterVariantSku: string,
	singleGrossPriceCents: number,
	brand: string,
	category: string,
) => {
	pushEventToDataLayer({ ecommerce: null })
	const singleGrossPriceEuros = singleGrossPriceCents / 100

	const item: GA4Item = {
		item_id: masterVariantSku,
		item_name: name,
		price: singleGrossPriceEuros,
		item_brand: brand,
		item_category: category,
		quantity: 1,
	}

	const event: GA4ViewItemEvent = {
		event: "view_item",
		ecommerce: {
			items: [item],
		},
	}

	pushEventToDataLayer(event)
}
